__turbopack_context__.v({
  "DistibutorCard": "ZkjXBG_DistibutorCard",
  "DistibutorCard__Container": "ZkjXBG_DistibutorCard__Container",
  "DistibutorCard__Image": "ZkjXBG_DistibutorCard__Image",
  "DistibutorCard__Image--Loaded": "ZkjXBG_DistibutorCard__Image--Loaded",
  "DistibutorCard__ImageTitleWrapper": "ZkjXBG_DistibutorCard__ImageTitleWrapper",
  "DistibutorCard__ImageWrapper": "ZkjXBG_DistibutorCard__ImageWrapper",
  "DistibutorCard__InfoGrid": "ZkjXBG_DistibutorCard__InfoGrid",
  "DistibutorCard__Title": "ZkjXBG_DistibutorCard__Title",
});
